import { useQuery } from '@tanstack/react-query';
import BreadcrumbsComponent from 'components/BreadcrumbsComponent';
import DetailSchoolSection from 'modules/pages/dacum/schoolManagement/DetailSchoolSection';
import LoaderSection from 'modules/pages/dacum/schoolManagement/LoaderSection';
import React from 'react';
import { useParams } from 'react-router-dom';
import { pathnames } from 'routes/dacum';
import { schoolService } from 'services/dacum/school.service';

const DetailSchoolPage = () => {
  const params = useParams();

  const { id } = params;

  const { data, isLoading } = useQuery({
    queryKey: ['schoolManagementDetail', id],
    queryFn: () => schoolService.detailSchool(id as string),
    enabled: !!id,
    select: (response) => response.data
  });

  const breadcrumbs = [
    { title: 'School Management', href: pathnames.schoolManagement },
    { title: 'Detail School Management', href: '' }
  ];
  return (
    <>
      <BreadcrumbsComponent items={breadcrumbs} mb={32} />

      {isLoading && <LoaderSection />}

      {!isLoading && data && <DetailSchoolSection data={data} />}
    </>
  );
};

export default DetailSchoolPage;
